import { ParamValue } from 'src/hooks/useFilters'
import { ALL_SELECT_OPTION } from 'src/utils/form'
import { inferQueryInput } from 'src/utils/trpc'

export enum ProjectView {
  Grid = 'gridview',
  Map = 'mapview'
}
type QueryInput = inferQueryInput<'projects.listProjects'>

export const buildQueryInput = ({
  purpose,
  regionId,
  orderBy,
  searchQuery,
  limit,
  offset,
  selectedView,
  publicPageOnly,
  approvedApplicationsOnly,
  currentSeasonOnly
}: {
  purpose: ParamValue | null
  regionId?: ParamValue | null
  orderBy: QueryInput['orderBy']
  searchQuery?: string
  selectedView: ProjectView
  limit: number
  offset: number
  publicPageOnly: boolean
  approvedApplicationsOnly: boolean
  currentSeasonOnly?: boolean
}): QueryInput => {
  return {
    publicPageOnly,
    purposes:
      purpose && purpose !== ALL_SELECT_OPTION.value ? [purpose as string] : [],
    regionId:
      regionId && regionId !== ALL_SELECT_OPTION.value
        ? (regionId as string)
        : undefined,
    limit: selectedView === ProjectView.Map ? 100_000 : limit,
    offset: selectedView === ProjectView.Map ? 0 : offset,
    orderBy,
    searchQuery,
    featuredOn: [],
    approvedApplicationsOnly: approvedApplicationsOnly ?? false,
    currentSeasonOnly: currentSeasonOnly ?? false
  }
}
